// extracted by css-extract-rspack-plugin
export default {"Lecture":"kftWB","Lecture__attendanceStatus":"p2y5h","Lecture__attendance":"oeDbG","Lecture__attendanceIcon":"ETAkN","Lecture__absenseReason":"FgbyE"};